module.exports = __webpack_public_path__ + "img/994d369.png";